'use client';

import * as React from 'react';

export const SelfVideoCollapseContext = React.createContext<{
  collapsed: boolean;
  toggle: () => void;
}>({ collapsed: false, toggle: () => undefined });
